module.exports = "/lucky-balls/img/btn-background-black.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/btn-background-black.png
// module id = 97
// module chunks = 0